import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=4f5a3000&scoped=true&"
import script from "./PlanCard.vue?vue&type=script&lang=ts&"
export * from "./PlanCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=4f5a3000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a3000",
  null
  
)

export default component.exports